import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import React from 'react';
import App from '../App';
import {
  CheckoutPaymentSummary,
  CheckoutPaymentDeliveryPreference,
  CheckoutSelectExemption,
  CheckoutUploadEvidence,
  Error404,
  SignupAddress,
  SignupGP,
  SignupPassword,
  SignupPasswordSuccess,
  // SignupVerifyEmail,
  SignupName,
  SignupPhoneDOB,
  SignupWaiting,
  Maintenance,
} from '../pages';
import {
  getAuthEmail,
  getAuthPharmacyId,
  getCheckoutInvoiceId,
  getCheckoutSelectedExemptionNeedsEvidence,
  getIdToken,
  getSignupAddressLine1,
  getSignupAddressLine2,
  getSignupDOBDate,
  getSignupFirstName,
  getSignupGPId,
  getSignupHasMarketingConsent,
  getSignupPhoneNumber,
  getSignupPostcode,
  getSignupSurname,
  getSignupTownCity,
  getUserIsApproved,
  getUserIsSignedUp,
} from '../redux/modules/root-reducer';
import createCheckoutExemptPage from '../pages/Checkout/AreYouExempt';
import createCheckoutComplete from '../pages/Checkout/Complete';
import createCheckoutDeclaration from '../pages/Checkout/Declaration';
import createOrderMedicineSearchPage from '../pages/CreateOrder/MedicineSearch';
import createOrderChoosePage from '../pages/CreateOrder/ChooseOrder';
import createOrderSelectMedicineFormPage from '../pages/CreateOrder/SelectMedicineForm';
import createOrderSelectMedicineStrengthPage from '../pages/CreateOrder/SelectMedicineStrength';
import createOrderReorderPage from '../pages/CreateOrder/Reorder';
import createOrderBasketPage from '../pages/CreateOrder/Basket';
import signupReadyPage from '../pages/Signup/Ready';
import signupConsentPage from '../pages/Signup/Consent';
import signupCompletePage from '../pages/Signup/Complete';
import signupVerifyEmail from '../pages/Signup/VerifyEmail';
import createOrderSchedulingPage from '../pages/CreateOrder/Scheduling/Calendar';
import createOrderSummaryPage from '../pages/CreateOrder/Summary';
import createOrderCompletePage from '../pages/CreateOrder/Complete';
import createOrderChangeAddressPage from '../pages/CreateOrder/ChangeAddress';
import createOrderCCStoreLocation from '../pages/CreateOrder/ChooseCCStoreLocation';
import createOrderCCConfirmLocation from '../pages/CreateOrder/ConfirmCCPharmacy';
import createEvidenceConfirmationPage from '../pages/Checkout/EvidenceConfirmation';
import createOrderApprovedPage from '../pages/Checkout/OrderApproved';
import createPaymentDetailsPage from '../pages/Checkout/PaymentDetails';
import createLeadTimePage from '../pages/CreateOrder/Scheduling/LeadTime';
import loginFormPage from '../pages/Login/Form';
import loginCodePage from '../pages/Login/PinCode';
import ordersPage from '../pages/Orders';
import changeOrderDeliveryAddress from '../pages/Orders/ChangeDeliveryAddress';
import changeDeliveryPreference from '../pages/Orders/ChangeDeliveryPreference';
import changeOrderClickAndCollect from '../pages/Orders/ChooseCCStoreLocation';
import ConfirmCCStore from '../pages/Orders/ConfirmCCPharmacy';
import ConnectedNMSPage, {
  NMSFormPreview,
  NMSAcceptedPreview,
  NMSDeclinedPreview,
  NMSExpiredPreview,
  NMSAlreadyRespondedPreview,
} from '../pages/NMS';

import paths from './paths';
import {
  fetchInvoiceForOrder,
  resetEvidenceSkipped,
} from '../redux/modules/checkout';
import routeForPage from './conditional-react';
import { createUser, fetchUser } from '../redux/modules/user';
import { setDeliveryPrefFlow } from '../redux/modules/orders';

const conditionalRoute = (fn, route) => (Component) => {
  const Wrapper = connect((state) => ({ isValid: fn(state) }))(
    ({ isValid, ...props }) =>
      isValid ? <Component {...props} /> : <Redirect to={route} />
  );
  Wrapper.isValid = (state) =>
    fn(state) && (!Component.isValid || Component.isValid(state));
  return Wrapper;
};

const whenLoggedIn = conditionalRoute(
  (state) => getIdToken(state) != null,
  paths.login.root
);

const whenHasInvoiceNeedsPaying = conditionalRoute(
  (state) => getCheckoutInvoiceId(state),
  '/'
);

const whenRequiresEvidence = conditionalRoute(
  (state) => getCheckoutSelectedExemptionNeedsEvidence(state),
  paths.checkout.declaration
);

const whenUserNotApproved = conditionalRoute(
  (state) => !getUserIsApproved(state),
  '/'
);

const whenUserNotSignedUp = conditionalRoute(
  (state) => !getUserIsSignedUp(state),
  '/'
);

const Empty = () => <div />;

const routes = [
  {
    component: App,
    routes: [
      {
        path: '/nms/preview/form',
        exact: true,
        component: NMSFormPreview,
      },
      {
        path: '/nms',
        exact: true,
        component: NMSFormPreview,
      },
      {
        path: '/nms/preview/accepted',
        exact: true,
        component: NMSAcceptedPreview,
      },
      {
        path: '/nms/preview/declined',
        exact: true,
        component: NMSDeclinedPreview,
      },
      {
        path: '/nms/preview/expired',
        exact: true,
        component: NMSExpiredPreview,
      },
      {
        path: '/nms/preview/already-responded',
        exact: true,
        component: NMSAlreadyRespondedPreview,
      },
      {
        path: '/nms/:token',
        exact: true,
        component: ConnectedNMSPage,
      },
      routeForPage(createCheckoutExemptPage),
      routeForPage(createCheckoutComplete),
      routeForPage(createCheckoutDeclaration),
      routeForPage(createOrderMedicineSearchPage),
      routeForPage(createOrderChoosePage),
      routeForPage(createOrderSelectMedicineFormPage),
      routeForPage(createOrderSelectMedicineStrengthPage),
      routeForPage(createOrderReorderPage),
      routeForPage(createOrderBasketPage),
      routeForPage(signupReadyPage),
      routeForPage(createOrderSummaryPage),
      routeForPage(createEvidenceConfirmationPage),
      routeForPage(createOrderApprovedPage),
      routeForPage(createPaymentDetailsPage),
      routeForPage(signupConsentPage),
      routeForPage(signupCompletePage),
      routeForPage(ordersPage),
      routeForPage(createOrderSchedulingPage),
      routeForPage(createOrderChangeAddressPage),
      routeForPage(createLeadTimePage),
      routeForPage(loginFormPage),
      routeForPage(loginCodePage),
      routeForPage(changeOrderDeliveryAddress),
      routeForPage(changeDeliveryPreference),
      routeForPage(changeOrderClickAndCollect),
      routeForPage(createOrderCompletePage),
      routeForPage(signupVerifyEmail),
      routeForPage(ConfirmCCStore),
      routeForPage(createOrderCCStoreLocation),
      routeForPage(createOrderCCConfirmLocation),
      {
        path: paths.checkout.exemptions,
        exact: true,
        component: whenHasInvoiceNeedsPaying(
          whenLoggedIn(CheckoutSelectExemption)
        ),
      },
      {
        path: '/order/:orderId/checkout',
        exact: true,
        component: whenLoggedIn(Empty),
        action: ({ params }) => {
          let { orderId } = params;
          if (!params.orderId.startsWith('S')) {
            orderId = `S${orderId}`;
          }
          return fetchInvoiceForOrder(orderId);
        },
      },
      {
        path: paths.checkout.uploadEvidence,
        exact: true,
        component: whenLoggedIn(
          whenHasInvoiceNeedsPaying(
            whenRequiresEvidence(CheckoutUploadEvidence)
          )
        ),
        action: () => resetEvidenceSkipped(),
      },
      {
        path: paths.checkout.paymentSummary,
        exact: true,
        component: whenLoggedIn(
          whenHasInvoiceNeedsPaying(CheckoutPaymentSummary)
        ),
      },
      {
        path: paths.checkout.paymentDeliveryPreference,
        exact: true,
        component: whenLoggedIn(
          whenHasInvoiceNeedsPaying(CheckoutPaymentDeliveryPreference)
        ),
        action: () => setDeliveryPrefFlow('checkout'),
      },
      {
        path: paths.signup.root,
        exact: true,
        component: whenUserNotSignedUp(() => (
          <Redirect to={paths.signup.name} />
        )),
      },
      {
        path: paths.signup.password,
        exact: true,
        component: whenUserNotSignedUp(whenLoggedIn(SignupPassword)),
      },
      {
        path: paths.signup.passwordsuccess,
        exact: true,
        component: whenUserNotSignedUp(whenLoggedIn(SignupPasswordSuccess)),
      },
      {
        path: paths.signup.name,
        exact: true,
        component: whenUserNotSignedUp(whenLoggedIn(SignupName)),
      },
      {
        path: paths.signup.address,
        exact: true,
        component: whenUserNotSignedUp(whenLoggedIn(SignupAddress)),
      },
      {
        path: paths.signup.phoneAndDOB,
        exact: true,
        component: whenUserNotSignedUp(whenLoggedIn(SignupPhoneDOB)),
      },
      {
        path: paths.signup.waiting,
        exact: true,
        component: whenLoggedIn(whenUserNotApproved(SignupWaiting)),
        action: () => fetchUser(),
      },
      {
        path: paths.signup.gpDetails,
        exact: true,
        component: whenUserNotSignedUp(whenLoggedIn(SignupGP)),
      },
      {
        path: paths.signup.createUser,
        exact: true,
        component: whenUserNotSignedUp(whenLoggedIn(Empty)),
        action: ({ state }) => {
          const data = {
            firstName: getSignupFirstName(state),
            lastName: getSignupSurname(state),
            dob: getSignupDOBDate(state),
            phone: getSignupPhoneNumber(state),
            addressLine1: getSignupAddressLine1(state),
            addressLine2: getSignupAddressLine2(state),
            addressTownCity: getSignupTownCity(state),
            addressPostcode: getSignupPostcode(state),
            gpId: getSignupGPId(state),
            email: getAuthEmail(state),
            pharmacyId: getAuthPharmacyId(state),
            emailConsent: getSignupHasMarketingConsent(state),
          };
          return createUser(data);
        },
      },
      {
        path: '*',
        component: Error404,
      },
    ],
  },
];

export const maintenanceRoutes = [
  {
    component: App,
    routes: [
      {
        path: '*',
        component: Maintenance,
      },
    ],
  },
];

export default routes;
